'use client';

import BreadCrumbs from '@components/breadcrumbs/BreadCrumbs';
import ROUTES from '@lib/constants/routes';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import { useParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';

import styles from './template.module.scss';

function TemplateAbout({ children }) {
  const { houseId, bulkId, floorId } = useParams();

  const { isDesktop } = useDeviceScreen();

  const currentCorpus = useMemo(() => {
    if (bulkId === '9758') return 'Корпус 2.1';
    if (bulkId === '10100') return 'Корпус 2.2';
    if (bulkId === '10099') return 'Корпус 2.3';

    return 'Корпус 1';
  }, [bulkId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadCrumbsApi = {
    color: '#1C1C1C',
    crumbs: [
      { id: 1, text: 'Главная', link: ROUTES.root },
      { id: 2, text: 'Генплан', link: houseId ? ROUTES.flats.visual.root : null },
      ...(houseId && bulkId !== '9335'
        ? [
            {
              id: 3,
              text: `Очередь ${houseId}`,
              link: bulkId ? `${ROUTES.flats.visual.root}/${houseId}` : null,
            },
          ]
        : []),
      ...(bulkId
        ? [
            {
              id: 4,
              text: currentCorpus,
              link: floorId ? `${ROUTES.flats.visual.root}/${houseId}/${bulkId}` : null,
            },
          ]
        : []),
      ...(floorId ? [{ id: 4, text: `Этаж ${floorId}` }] : []),
    ],
  };

  return (
    <>
      <div className={styles.root}>{isDesktop && <BreadCrumbs item={breadCrumbsApi} />}</div>
      {children}
    </>
  );
}

export default TemplateAbout;
